import { render } from "./d-list-item-view.vue?vue&type=template&id=6bdfdb5c&scoped=true&ts=true"
import script from "./d-list-item-view.vue?vue&type=script&lang=ts"
export * from "./d-list-item-view.vue?vue&type=script&lang=ts"

import "./d-list-item-view.vue?vue&type=style&index=0&id=6bdfdb5c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdfdb5c"]])

export default __exports__